<template>
  <div class="fis-account-list">
    <div class="select">
      <div class="select-desc">
        Select a wallet
      </div>
      <div class="account-items">
        <template v-for="(item, index) in accountList">
          <div :key="index" class="account-item" @click="selectAccount(index)">
            <div class="left">
              <div class="name">
                {{ item.name }}
              </div>
              <div class="address">
                {{ item.address }}
              </div>
            </div>
            <div class="balance">
              {{ item.balance }}
            </div>
            <div class="right">
              <div v-if="selectIndex == index" class="icon">
                <img src="../assets/active.png" />
              </div>
              <div v-else class="icon">
                <img src="../assets/inactive.png" />
              </div>
            </div>
          </div>
        </template>
      </div>
      <div class="confirm-btn" @click="confirm">
        Confirm
      </div>
    </div>
  </div>
</template>

<script>
import { setTimeout } from 'timers';
import rpc from '../util/rpc.js';
import { Toast } from 'mint-ui';
import LocalStorage from '../util/localStorage.js';
import NumberUtil from '../util/numberUtil.js';
import Api from '../util/SubstrateApi.js';
import {
  web3Enable,
  web3Accounts
} from '@polkadot/extension-dapp';
import keyring from '../keyring/Keyring.ts';

export default {
  name: 'fisAccountList',
  data() {
    return {
      selectIndex: 0,
      accountList: [],
      source: ''
    }
  },
  created() {
    if (this.$route.params) {
      this.source = this.$route.params.source;
    }

    const injectedPromise = web3Enable('stafi/rtoken');

    injectedPromise
      .then(() => web3Accounts())
      .then((accounts) => {
        if (accounts && accounts.length > 0) {
          const keyringInstance = keyring.init('fis');
          accounts.forEach(element => {
            let fisAddress = keyringInstance.encodeAddress(keyringInstance.decodeAddress(element.address));
            let account = {
              name: element.meta.name,
              address: fisAddress,
              balance: '--'
            };
            this.accountList.push(account);
          });

          this.accountList.forEach(account => {
            Api.createStafiApi().then(api => {
              api.query.system.account(account.address).then(result => {
                if (result) {
                  let fisFreeBalance = NumberUtil.fisAmountToHuman(result.data.free);
                  account.balance = NumberUtil.handleFisAmountToFixed(fisFreeBalance);
                }
              }).catch((error) => {});
            })
            .catch((error) => {});
          });

          this.initCurrentAddress();
        }
      })
      .catch();
  },

  methods: {
    initCurrentAddress() {
      if (this.accountList) {
        let currentAddress = LocalStorage.getCurrentFisAccount();
        if (currentAddress) {
          let index = 0;
          let isFind = false;
          this.accountList.some((account) => {
            if (account.address == currentAddress) {
              this.selectIndex = index;
              isFind = true;
              this.$emit('handleFisAccount');
              return true;
            }
            index++;
          });
          if (!isFind) {
            LocalStorage.setCurrentFisAccount(this.accountList[0].address);
            this.$emit('handleFisAccount');
          }
        } else {
          LocalStorage.setCurrentFisAccount(this.accountList[0].address);
          this.$emit('handleFisAccount');
        }
      }
    },

    confirm() {
      let currentItem = this.accountList[this.selectIndex];
      LocalStorage.setCurrentFisAccount(currentItem.address);
      this.$emit('handleFisAccount');

      if (this.source) {
        if (this.source.indexOf('fis') != -1) {
          this.$router.push('/rfis');
        } else if (this.source.indexOf('bridge') != -1) {
          this.$router.push('/rbridge');
        }
      } else {
        this.$router.push('/rfis');
      }
      
    },
    selectAccount(index) {
      this.selectIndex = index;
    }
  }
}
</script>

<style lang="scss">
@import "../mixin.scss";

.fis-account-list {
  background-color: #2B3239;
  width: 683px;
  border-radius: 19px;

  .select {
    padding: 36px 50px;

    .select-desc {
      font-size: 30px;
      font-weight: bold;
      margin-bottom: 10px;
    }
    
    .account-items {

      .account-item {
        display: flex;
        border: 1px solid #979797;
        border-radius: 7px;
        padding: 14px 20px;
        margin-bottom: 20px;
        cursor: pointer;

        .left {
          flex: 1;
          .name {
            font-size: 20px;
            margin-bottom: 8px;
          }

          .address {
            font-size: 12px;
          }
        }

        .balance {
          line-height: 45px;
          margin-right: 5px;
          font-size: 18px;
          font-weight: bold;
        }

        .right {
          margin: auto;

          .icon {
            width: 36px;
            height: 36px;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }

    .confirm-btn {
      cursor: pointer;
      margin-left: 462px;
      width: 110px;
      height: 42px;
      line-height: 42px;
      font-size: 16px;
      color: #23292F;
      font-weight: bold;
      background-color: #00F3AB;
      border-radius: 21px;
      text-align: center;
      margin-top: 50px;
    }
  }
}
</style>
